// import qs from 'qs';
import client from './client';

export default {
  async currentUser() {
    const response = await client.get('account/current-user/');
    return response.data;
  },

  async getProfile() {
    const response = await client.get('account/profile/');
    return response.data;
  },

  async publishProfile(id) {
    const response = await client.patch(`account/mam/coach/${id}/publish/`);
    return response.data;
  },

  // get list of languages that coach can choose to coach
  async getLanguages() {
    const response = await client.get('common/language/');
    return response.data;
  },

  async patchProfile(data) {
    const response = await client.patch('account/profile/', data);
    return response.data;
  },

  async viewProfile(url) {
    const response = await client.get(`account/profile/${url}/`);
    return response.data;
  },

  async getCountries() {
    const response = await client.get('common/countries/');
    return response.data;
  },

  async getRegions(id) {
    const response = await client.get(`common/country/${id}/regions/`);
    return response.data;
  },

  async getCities(id) {
    const response = await client.get(`common/region/${id}/cities/`);
    return response.data;
  },

  async urlIndexValidate(url) {
    const response = await client.get(`account/profile/${url}/validate/`);
    return response.data;
  },

  // Coach demographic
  async getCoachDemographics() {
    const response = await client.get('account/gcg-demographics/');
    return response.data;
  },

  async createCoachDemographics(data) {
    const response = await client.post('account/gcg-demographics/', data);
    return response.data;
  },

  async updateCoachDemographics(data) {
    const response = await client.patch('account/gcg-demographics/', data);
    return response.data;
  },
};
